import React from 'react';
import {
  Box,
  Dialog,
  DialogProps,
  IconButton,
  Slide,
  SlideProps,
  Theme,
  useMediaQuery
} from '@mui/material';
import { makeStyles, withStyles } from 'tss-react/mui';
import { Breakpoint } from '@mui/material/styles';
import { Close } from '@mui/icons-material';


export const ModalFullPageTransition: React.FC<SlideProps> = (props) => {
  return <Slide direction="up" {...props} />;
};

export type ModalFullPageType = {
  open?: boolean;
  mobileOnly?: boolean | Breakpoint;
  onClose?: () => void;
  closeIcon?: React.ReactNode | boolean;
  transition?: boolean;
  children: React.ReactNode | ((args: ModalFullPageRenderCallbackArgs) => React.ReactNode);
  onExited?: () => void;
} & Pick<DialogProps, 'BackdropProps' | 'keepMounted' | 'maxWidth' | 'classes' | 'slotProps' | 'slots'>;

export type ModalFullPageRenderCallbackArgs = {
  displayMobileOnlyStyles?: boolean;
  showBottomDivider?: boolean;
};


export const ModalFullPageRaw: React.FC<ModalFullPageType> = ({
  open = true,
  children,
  classes: modalClasses,
  mobileOnly = false,
  onClose,
  closeIcon,
  transition,
  maxWidth,
  keepMounted,
  BackdropProps,
  onExited,
  ...props
}) => {
  const isMobile = useMediaQuery<Theme>(theme => theme.breakpoints.down(typeof mobileOnly === 'boolean' ? 'sm' : mobileOnly));
  const { classes } = useStyles();
  const displayMobileOnlyStyles = !mobileOnly || isMobile;

  return (
    <Dialog
      {...props}
      open={open}
      classes={modalClasses}
      maxWidth={maxWidth}
      fullWidth
      keepMounted={keepMounted}
      fullScreen={mobileOnly ? isMobile : true}
      TransitionComponent={(displayMobileOnlyStyles && transition === true) ? ModalFullPageTransition : undefined}
      onClose={onClose}
      slotProps={{
        backdrop: BackdropProps,
      }}
      TransitionProps={{ onExited }}
    >
      {closeIcon && (
        <Box className={classes.closeIconContainer}>
          {typeof closeIcon === 'boolean' ? (
            <IconButton onClick={onClose}>
              <Close />
            </IconButton>
          ) : closeIcon}
        </Box>
      )}
      {typeof children === 'function'
        ? children({ displayMobileOnlyStyles })
        : children}
    </Dialog>
  );
};

export const ModalFullPage = withStyles(ModalFullPageRaw, {
  root: {
    // position: 'relative',
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
  },
  paperFullScreen: {
    borderRadius: 0,
  }
});


const useStyles = makeStyles()((theme) => ({
  closeIconContainer: {
    position: 'absolute',
    right: theme.spacing(.75),
    top: theme.spacing(.75),
  }
}));
